import React from "react";
import { Link } from "react-router-dom";
import { COMPANY } from "../constants/company";

export default function ThankYou() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-10 px-4">
      <div className="max-w-2xl w-full bg-white shadow-lg rounded-3xl p-8 text-center border border-gray-200">

        {/* Check Icon */}
        <div className="flex justify-center mb-6">
          <div className="h-16 w-16 flex items-center justify-center rounded-full bg-emerald-100 text-emerald-600">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-10 w-10"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
            </svg>
          </div>
        </div>

        {/* Title */}
        <h1 className="text-2xl sm:text-3xl font-bold text-gray-900">
          Thank You for Accepting the Terms!
        </h1>

        {/* Subtext */}
        <p className="mt-3 text-gray-700">
          Your agreement has been successfully accepted. A signed PDF copy has
          been sent to your email address.
        </p>

        {/* Info Box */}
        <div className="mt-6 rounded-xl bg-blue-50 border border-blue-200 p-5 text-blue-800">
          <h2 className="font-semibold text-base mb-1">What happens next?</h2>
          <p className="text-sm leading-relaxed">
            Please check your email inbox for the PDF copy of your signed agreement.
            The document will be available for download.
          </p>
        </div>

        <div className="my-8 border-t border-gray-200"></div>

        {/* Support Text */}
        <p className="text-sm text-gray-600">
          If you have any questions or need assistance, please contact us at{" "}
          <a
            href="mailto:support@dgsharemarketresearch.com"
            className="text-blue-600 underline underline-offset-2"
          >
            {COMPANY.CONTACT.EMAIL}
          </a>
        </p>

        {/* Button */}
        <div className="mt-6">
          <Link
            to="/"
            className="inline-flex items-center justify-center rounded-lg bg-emerald-600 px-6 py-3 text-white text-sm font-semibold shadow hover:bg-emerald-700"
          >
            Back to Home
          </Link>
        </div>

      </div>
    </div>
  );
}
